import React from 'react';
import { connect } from 'react-redux';
import LandingPageRender from './LandingPageRender';
import * as GlobalActions from '../../reducers/actions';
import { bindActionCreators } from 'redux';
import { debounce } from '../../utils/functionUtils';
import view, { oyoFormView, propertyType } from '../../Enums';
import { Event } from './Tracking/Track';
import { extraHeightForHotelRoom } from '../../common/DefaultValues';
import Component from '../../ui-components/Component';
import LandingStyles from './LandingStyles';
import LandingImages from './LandingImages';
import {
  parseJsonString,
  merge,
  notIsEmptyString,
  path,
  notIsEmptyList,
  checkMobileAndTabletBrowser
} from '../../utils';
import { getConcatanatedUTMData, getCtaLinkWithUtmParams } from '../../utils/campaignUtils';
import { earningPotentialEnabled, hmsSelfOnboardingEnabled } from '../../config/countryConfig';
import {  guc } from '../../services/Localisation';
import Network from '../../services/Network';
import {TRANSLATION_AND_IMAGES}  from '../../utils/endpoints';
import * as TranslationActions from '../../reducers/TranslationsReducer/actions';
import { Carousel } from 'react-responsive-carousel';
import Parser from 'react-html-parser';
import ButtonBase from '@material-ui/core/ButtonBase';
import { HMS_LOGIN_URL } from '../../ApiConstants';
import WhyJoinOyo from '../../ui-components/WhyJoinOyoStrip/components/Card';
import IframeLandingPage from './IframeLandingPage';

class LandingPageScreen extends Component {

  translation_key = 'landing_translations';
  styles = LandingStyles;
  images = LandingImages;
  
  getViewMode = () => this.state.viewMode;

  constructor(props) {
    super(props);
    this.setWhyOyo2Ref = this.setWhyOyo2Ref.bind(this);
    this.landingImageLoad = this.landingImageLoad.bind(this);
    this.link = this.link.bind(this);
    this.handleCloseModalKnowMore = this.handleCloseModalKnowMore.bind(this);
    this.handleOpenVideoModal = this.handleOpenVideoModal.bind(this);
    this.handleCloseVideoModal = this.handleCloseVideoModal.bind(this);
    this.setExtraFormHeight = this.setExtraFormHeight.bind(this);
    this.handleScrollToForm = this.handleScrollToForm.bind(this);
    this.giveAbilityToChangeOyoForm = this.giveAbilityToChangeOyoForm.bind(
      this
    );
    this.fMessageModal = this.fMessageModal.bind(this);
    this.showMessageModal = this.showMessageModal.bind(this);
  }

  state = {
    landingParent:null,
    viewSize: null,
    viewMode: null,
    landingImageHeight: 600,
    whyOyo2Ref: null,
    hideWhyOyo: true,
    rightMargin: 130,
    borderTopBecomeOyoForm: 189,
    becomeOyoFormHeight: 463,
    becomeOyoFormExtraHeight: 0,
    headerAppeared: false,
    showVideoModal: false,
    youtubeId: '',
    imageLoaded: false,
    headerTop: -84,
    headerAppearsAt: 400,
    header: '',
    showModal: false,
    fullContent: '',
    imgKnowMore: '',
    mobileVsmall: false,
    landingImageRef: null,
    landingImageView: false,
    whyOyo2Ref: null,
    whyOyoInView: false,
    opmsRef: null,
    opmsView: false,
    stepsToPartnerRef: null,
    stepsToPartnerView: false,
    peopleCheckInRef: null,
    peopleCheckInView: false,
    hearFromPartnersRef: null,
    hearFromPartnersView: false,
    readyRef: null,
    readyView: false,
    footerView: false,
    footerRef: null,
    amount: 16900,
    highLightForm: false,
    showMessageModal: false,
    messageModalHeading: '',
    messageModalBody: '',
    changeOyoForm: null,
    utm_data: null,
    landingCarouselList: null,
    mobileLandingCarouselList: null,
    mobileLandingCarouselHeading: null,
    additionalHeaderStyles: {}
  };

  fMessageModal = bool => {
    this.setState({ showMessageModal: bool });
  };

  showMessageModal = (heading, body) => {
    this.setState({
      showMessageModal: true,
      messageModalHeading: heading,
      messageModalBody: body
    });
  };

  giveAbilityToChangeOyoForm = f => {
    this.setState({ changeOyoForm: f });
  };

  handleScrollToForm = () => {
    this.setState({ highLightForm: true });

    setTimeout(() => {
      this.setState({ highLightForm: false });
    }, 2000);

    if (this.state.viewMode == view.DESKTOP) {
      this.state.landingParent.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this.state.landingParent.scrollTo({
        top:
          this.state.landingImageHeight -
          this.state.becomeOyoFormHeight / 2 -
          80,
        behavior: 'smooth'
      });
    }
  };

  setLandingImageRef = ref => {
    this.setState({ landingImageRef: ref });
  };
  setFooterRef = ref => {
    this.setState({ footerRef: ref });
  };

  setWhyOyo2Ref = ref => {
    this.setState({ whyOyo2Ref: ref });
  };

  setOpmsRef = ref => {
    this.setState({ opmsRef: ref });
  };

  setStepsToPartnerRef = ref => {
    this.setState({ stepsToPartnerRef: ref });
  };

  setPeopleCheckInRef = ref => {
    this.setState({ peopleCheckInRef: ref });
  };

  setHearFromPartnersRef = ref => {
    this.setState({ hearFromPartnersRef: ref });
  };

  setReadyRef = ref => {
    this.setState({ readyRef: ref });
  };

  setParentRef = ref => {
    this.setState({landingParent:ref})
    ref && ref.scrollTo(0,0);
  }

  link = (viewMode, fullContent, header, imgKnowMore) => {
    this.setState({
      showModal: true,
      fullContent: fullContent,
      header: header,
      imgKnowMore: imgKnowMore,
      viewMode: viewMode
    });
  };

  handleCloseModalKnowMore = () => {
    this.setState({ showModal: false, fullContent: '', header: '' });
  };
  handleOpenVideoModal = (youtubeId, header) => {
    this.setState({
      showVideoModal: true,
      youtubeId: youtubeId,
      header: header
    });
  };

  handleCloseVideoModal = () => {
    this.setState({ showVideoModal: false, youtubeId: '', header: '' });
  };

  landingImageLoad = () => {
    if(!hmsSelfOnboardingEnabled() && path(window,'__SERVER_DATA__.translationsData.goToLoginForm',false)){
      this.handleScrollToForm();
      if(typeof this.state.changeOyoForm === 'function'){
        this.state.changeOyoForm(oyoFormView.loginScreen);
      }
    }
    this.setState({ imageLoaded: true }, () => this.landingResizeHandler());
  };

  setExtraFormHeight = () => {
    if (this.props.globalData.locale !== 'in') return 0;
    let heightExtension = 0;
    if (this.props.globalData.type_of_property === propertyType.HOTEL) {
      heightExtension += extraHeightForHotelRoom[this.state.viewMode];
    } else {
      heightExtension = 0;
    }

    this.setState({
      becomeOyoFormExtraHeight: heightExtension
    });
  };
  
  setUtmData = () => {
    let { utm_source, utm_medium, utm_campaign } = this.props.globalData;
    const utm_data= getConcatanatedUTMData([
      utm_source,
      utm_medium,
      utm_campaign
    ]);
    this.setState({utm_data:utm_data});
  };
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    
    if(this.hasPropChanged(prevProps,'globalData.loginData.isFetching')){
      if(!this.props.globalData.loginData.isFetching){
        if(path(this.props.globalData.loginData.data,'access_token')){
          window.location.replace(this.props.globalData.locale+'/properties')
        }
      }
    }
    
    if(this.hasPropChanged(prevProps,'resizeData.width','resizeData.height')){
      this.landingResizeHandler()
    }
    
    if (
      prevProps.globalData.type_of_property !==
      this.props.globalData.type_of_property
    )
      this.setExtraFormHeight();

    if (
      prevProps.globalData.selected_location !=
        this.props.globalData.selected_location &&
      this.props.globalData.selected_location !== null &&
        earningPotentialEnabled()
    ) {
      let loc = this.props.globalData.selected_location;
      let countryId, cityId;
      if (loc.country) countryId = loc.country.id;
      if (loc.city) {
        cityId = loc.city.id;
        this.props.globalActions.getEarningPotential(countryId, cityId);
      } else {
        // Pre empt response
        this.props.globalActions.successGetEarningPotential({});
      }
    }

    if (
      this.props.globalData.earning_potential_data.isFetching !=
      prevProps.globalData.earning_potential_data.isFetching
    ) {
      this.setExtraFormHeight();
    }
  }

  scrollListener = () => {
    var landingParent = this.state.landingParent;
    if(landingParent == null)return
    if (this.state.imageLoaded) {
      let docScroll = landingParent.scrollTop
      if (docScroll < this.state.headerAppearsAt) {
        this.setState({ headerAppeared: false, headerTop: -86 });
      } else if (docScroll > this.state.headerAppearsAt) {
        this.setState({ headerAppeared: true, headerTop: 0 });
      }
    }

    if (this.state.hideWhyOyo && this.state.whyOyo2Ref != null) {
      let topOffset = this.state.whyOyo2Ref.offsetTop;
      let docScroll = landingParent.scrollTop
      let docInView = docScroll + window.innerHeight;
      if (docInView > topOffset + 186) {
        this.setState({ hideWhyOyo: false });
      }
    }

    let scrollTop = landingParent.scrollTop

    //check for landing view

    // check for why oyo in view
    if (
      scrollTop + window.innerHeight >
      this.state.whyOyo2Ref.offsetTop +
      this.state.whyOyo2Ref.clientHeight / 2 &&
      scrollTop <
      this.state.whyOyo2Ref.offsetTop + this.state.whyOyo2Ref.clientHeight
    ) {
      if (!this.state.whyOyoInView) {
        this.setState({ whyOyoInView: true });

        Event('Partner Page', 'Why Join OYO viewed', '', '');
      }
    } else {
      if (this.state.whyOyoInView) {
        this.setState({ whyOyoInView: false });
      }
    }
    // check for view opms

    if (
      scrollTop + window.innerHeight >
      this.state.opmsRef.offsetTop + this.state.opmsRef.clientHeight / 2 &&
      scrollTop <
      this.state.opmsRef.offsetTop + this.state.opmsRef.clientHeight
    ) {
      if (!this.state.opmsView) {
        this.setState({ opmsView: true });
        // fire the event
        Event('Partner Page', 'Property Management System viewed', '', '');
      }
    } else {
      if (this.state.opmsView) {
        this.setState({ opmsView: false });
      }
    }
    //check for view steps to partner
    if (!hmsSelfOnboardingEnabled() &&
      scrollTop + window.innerHeight >
      this.state.stepsToPartnerRef.offsetTop +
      this.state.stepsToPartnerRef.clientHeight / 2 &&
      scrollTop <
      this.state.stepsToPartnerRef.offsetTop +
      this.state.stepsToPartnerRef.clientHeight
    ) {
      if (!this.state.stepsToPartnerView) {
        this.setState({ stepsToPartnerView: true });
        // fire the event
        Event('Partner Page', 'Steps to Partner with OYO viewed', '', '');
      }
    } else {
      if (this.state.stepsToPartnerView) {
        this.setState({ stepsToPartnerView: false });
      }
    }
    //check for view 5 people i veiw
    if ( this.state.peopleCheckInRef != null &&
      scrollTop + window.innerHeight >
      this.state.peopleCheckInRef.offsetTop +
      this.state.peopleCheckInRef.clientHeight / 2 &&
      scrollTop <
      this.state.peopleCheckInRef.offsetTop +
      this.state.peopleCheckInRef.clientHeight
    ) {
      if (!this.state.peopleCheckInView) {
        this.setState({ peopleCheckInView: true });
        // fire the event
        Event('Partner Page', '5 people check into OYO viewed', '', '');
      }
    } else {
      if (this.state.peopleCheckInView) {
        this.setState({ peopleCheckInView: false });
      }
    }
    //hear from partner
    if ( guc('testimonials_enabled','true') === 'true' &&
      scrollTop + window.innerHeight >
      this.state.hearFromPartnersRef.offsetTop +
      this.state.hearFromPartnersRef.clientHeight / 2 &&
      scrollTop <
      this.state.hearFromPartnersRef.offsetTop +
      this.state.hearFromPartnersRef.clientHeight
    ) {
      if (!this.state.hearFromPartnersView) {
        this.setState({ hearFromPartnersView: true });
        // fire the event
        Event('Partner Page', 'Hear from our Partners viewed', '', '');
      }
    } else {
      if (this.state.hearFromPartnersView) {
        this.setState({ hearFromPartnersView: false });
      }
    }

    //ready to get started
    if (
      scrollTop + window.innerHeight >
      this.state.readyRef.offsetTop +
      this.state.readyRef.clientHeight / 2 &&
      scrollTop <
      this.state.readyRef.offsetTop + this.state.readyRef.clientHeight
    ) {
      if (!this.state.readyView) {
        this.setState({ readyView: true });
        // fire the event
        Event('Partner Page', 'Ready to get started viewed', '', '');
      }
    } else {
      if (this.state.readyView) {
        this.setState({ readyView: false });
      }
    }

    if (
      scrollTop + window.innerHeight >
      this.state.footerRef.offsetTop +
      this.state.footerRef.clientHeight / 2 &&
      scrollTop <
      this.state.footerRef.offsetTop + this.state.footerRef.clientHeight
    ) {
      if (!this.state.footerView) {
        this.setState({ footerView: true });
        // fire the event
        Event('Partner Page', 'Footer viewed', '', '');
      }
    } else {
      if (this.state.footerView) {
        this.setState({ footerView: false });
      }
    }
  }

  componentDidMount() {
    

    if (this.props.globalData && !this.props.globalData.landing_translations) {
      const country= this.props.globalData.locale;
      const  locale= this.props.globalData.lang;
      Network.GET(TRANSLATION_AND_IMAGES, {
        country: country,
        locale: locale
      }, null, res => {
        this.props.globalActions.updateGlobalData(res);
        this.props.translationActions.updateTranslationsData(res);
      }, console.log);
    }
    if (notIsEmptyString(guc('landing_carousel_json')))
      parseJsonString('landing_carousel_json').then(jsonData => {
        if (jsonData.isValid && notIsEmptyList(path(jsonData.data,'carousels', {})))
          this.setState({ landingCarouselList: jsonData.data.carousels });
      });
    if (notIsEmptyString(guc('mobile_landing_carousel_json')))
      parseJsonString('mobile_landing_carousel_json').then(jsonData => {
        if (jsonData.isValid && notIsEmptyList(path(jsonData.data,'carousels', {}))) {
          this.setState({ mobileLandingCarouselList: jsonData.data.carousels });
          this.setState({ mobileLandingCarouselHeading: jsonData.data.carouselHeading });
        }
      });
    if (notIsEmptyString(guc('additional_header_styles')))
      parseJsonString('additional_header_styles').then(jsonData => {
        if (jsonData.isValid)
          this.setState({ additionalHeaderStyles: jsonData.data });
      });
    let screenRef = this;

    var landingParent = document.getElementById('landingPageParent');
    this.setUtmData();
    this.landingResizeHandler();
  }

  landingResizeHandler = () => {
    var w = window.innerWidth;
    var h = window.innerHeight;
    let rightMargin = w / 2 - 600;
    this.setState({ rightMargin: rightMargin });
    if (w < 1200) {
      this.props.globalActions.setHeadingHeightForMobile(true);
      let mobileVsmall = false;
      if (w <= 360) mobileVsmall = true;
      this.setState(
        {
          viewSize: 'Mobile',
          viewMode: view.MOBILE,
          changeOyoOsModuleStyle: w < 855 ? true : false,
          mobileVsmall: mobileVsmall
        },
        this.setExtraFormHeight
      );
    } else {
      let imageLandingHeight = 0.9 * h;
      imageLandingHeight = Math.max(600, imageLandingHeight);
      if (this.state.imageLoaded) {
        let element = document.getElementById('landingNewImage');
        if (element) {
          let imHeight = element.clientHeight;
          if (imHeight < imageLandingHeight) imageLandingHeight = imHeight;
        }
      }
      let borderTopBecomeOyoForm =
        (imageLandingHeight - this.state.becomeOyoFormHeight) / 2;
      this.setState(
        {
          landingImageHeight: imageLandingHeight,
          borderTopBecomeOyoForm: borderTopBecomeOyoForm,
          viewSize: 'Desktop',
          viewMode: view.DESKTOP
        },
        this.setExtraFormHeight
      );
    }
  };
  
  renderCarousel = () => {
    return <Carousel showArrows showStatus={false} stopOnHover={false} autoPlay infiniteLoop interval={5000}>
      {this.state.landingCarouselList.map(({ image, text, text_style, cta_text, cta_link }, i) => <div key={i} style={merge(this.gs('carousel_item'), { backgroundImage: `url(${image})` })}>
        <div style={merge(this.gs('carousel_text'), text_style)}>
          {Parser(text)} <br />
          {notIsEmptyString(cta_text) && <a href={getCtaLinkWithUtmParams(cta_link)} target='_blank'>
            <ButtonBase style={this.gs('cta_button')}>{cta_text}</ButtonBase>
          </a>}
        </div>
      </div>)}
    </Carousel>;
  };
  

  redirectToHms = () => {
    const redirectUrl = getCtaLinkWithUtmParams(HMS_LOGIN_URL);
    console.log('HMS_LOGIN_URL', redirectUrl);
    window.open(redirectUrl, '_self');
  };
  

  renderMobileCarousel = () => <>
    <div style={this.gs('bold_big_head')}>{this.state.mobileLandingCarouselHeading}</div>
    <div style={this.gs('tab_cards')} className='hideScrollbar'>
    <div style={this.gs('tab_cards_padding')} />
    {this.state.mobileLandingCarouselList.map(({title,image,description,id}) =>
        <WhyJoinOyo
            style={merge(this.gs('tab_card'))}
            titleStyle={this.gs('mobile_carousel_title')}
            descriptionStyle={this.gs('mobile_carousel_description')}
            image={image}
            title={title}
            description={description}
            key={id}/>
    )}
    <div style={this.gs('tab_cards_padding')} />
  </div></>;

  render() {
    // console.log(this.getViewMode())

    return (
      this.guc('landing_iframe_link')  ? <IframeLandingPage link={getCtaLinkWithUtmParams(this.guc('landing_iframe_link'))}/> :
      <LandingPageRender
        gc = {this.gc}
        guc = {this.guc}
        gs = {this.gs}
        gi = {this.gi}
        handleScrollToForm={this.handleScrollToForm}
        highLightForm={this.state.highLightForm}
        setWhyOyo2Ref={this.setWhyOyo2Ref}
        setOpmsRef={this.setOpmsRef}
        setStepsToPartnerRef={this.setStepsToPartnerRef}
        setPeopleCheckInRef={this.setPeopleCheckInRef}
        setHearFromPartnersRef={this.setHearFromPartnersRef}
        setReadyRef={this.setReadyRef}
        setFooterRef={this.setFooterRef}
        hideWhyOyo={this.state.hideWhyOyo}
        landingImageHeight={this.state.landingImageHeight}
        viewSize={this.state.viewSize}
        viewMode={this.state.viewMode}
        changeOyoOsModuleStyle={this.state.changeOyoOsModuleStyle}
        state={this.state}
        rightMarginForForm={this.state.rightMargin}
        borderTopBecomeOyoForm={this.state.borderTopBecomeOyoForm}
        becomeOyoFormHeight={this.state.becomeOyoFormHeight}
        becomeOyoFormExtraHeight={this.state.becomeOyoFormExtraHeight}
        headerAppeared={this.state.headerAppeared}
        landingImageLoad={this.landingImageLoad}
        imageLoaded={this.state.imageLoaded}
        headerTop={this.state.headerTop}
        handleOpenVideoModal={this.handleOpenVideoModal}
        handleCloseModalKnowMore={this.handleCloseModalKnowMore}
        handleCloseVideoModal={this.handleCloseVideoModal}
        link={this.link}
        header={this.state.header}
        showModal={this.state.showModal}
        fullContent={this.state.fullContent}
        showVideoModal={this.state.showVideoModal}
        imgKnowMore={this.state.imgKnowMore}
        mobileVsmall={this.state.mobileVsmall}
        amount={this.state.amount}
        giveAbilityToChangeOyoForm={this.giveAbilityToChangeOyoForm}
        changeOyoForm={this.state.changeOyoForm}
        fMessageModal={this.fMessageModal}
        showMessageModal={this.showMessageModal}
        scrollListener={debounce(this.scrollListener,100)}
        setParentRef={this.setParentRef}
        renderCarousel={this.renderCarousel}
        redirectToHms={this.redirectToHms}
        renderMobileCarousel={this.renderMobileCarousel}
        additionalHeaderStyles={this.state.additionalHeaderStyles}
      />
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch),
    translationActions: bindActionCreators(TranslationActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer,
    translationsData:state.translationsReducer,
    resizeData: state.resizeReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPageScreen);
